import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/price-list/PriceListClient.tsx");
